import React from 'react';
import SVG from 'react-inlinesvg';
import { Container, Page, GridRow } from './shared/styled/Assembly';
import CenteredIcon from './shared/CenteredIcon';
import { pictoWomp } from '../assets';

const AppNotFound = () => (
  <Page>
    <GridRow>
      <Container>
        <CenteredIcon>
          <SVG src={pictoWomp} />
        </CenteredIcon>
        <h1 className="text24--emphasis text-center">
          Oops, we couldn&#39;t find what you were looking for.
        </h1>
      </Container>
    </GridRow>
  </Page>
);

export default AppNotFound;
